/* Delilah product page bundle box.
   The bundle is the basket: eligible basket items fill the slots (3 for Buy 2 get 1, 5 once the bonus tier is reached).
   "Add to bundle" adds this piece with no basket pop-up. The theme's own button becomes "Just add to basket" (opens the basket).
   Each filled slot has an x to swap that piece out (removes one from the basket). */
(function () {
  if (window.__dlBundle) return; window.__dlBundle = true;

  var SPARE = ['flat-back-backs-gold', 'flat-back-backs-silver'];
  var ORD = ['', '1st', '2nd', '3rd', '4th', '5th'];

  function eligible(i) {
    if (SPARE.indexOf(i.handle) > -1) return false; // spare backs have their own separate offer
    if (i.gift_card || (i.product_type || '').toLowerCase() === 'add-on') return false;
    var p = i.original_price;
    return p > 700 && p < 3500;
  }
  function units(cart) {
    var out = [];
    cart.items.slice().reverse().forEach(function (i) { if (eligible(i)) for (var q = 0; q < i.quantity; q++) out.push(i); });
    return out;
  }
  function priceNum(s) { var v = parseFloat(String(s || '').replace(/[^0-9.]/g, '')); return isNaN(v) ? 0 : Math.round(v * 100); }
  // Is the piece on this page the one that will come off free if added now? (cheapest of 3, or 2 cheapest of 5)
  function isFree(b, n, u) {
    if (n !== 2 && n !== 4) return false;
    var k = n === 2 ? 1 : 2, me = priceNum(b.getAttribute('data-price'));
    var ps = u.map(function (i) { return i.original_price; }).sort(function (a, c) { return a - c; });
    return me > 0 && ps.length >= k && me <= ps[k - 1];
  }
  function priceHtml(pr, free) { return free ? '<s style="opacity:.6;font-weight:600">' + esc(pr) + '</s> FREE' : esc(pr); }
  function basketLabel(b, free) {
    var span = document.querySelector('.dl-basket-btn .btn-text > span');
    if (span && !span.hasAttribute('data-sold-out-shown')) span.innerHTML = 'Just add to basket · ' + priceHtml(b.getAttribute('data-price'), free);
  }
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function shortName(t) {
    var s = String(t || '').replace(/\b(Flat Back Studs?|Flat Backs|Screw Back Studs|Studs|Huggies|Hoops|Necklace|Gold|Silver)\b/gi, '').replace(/\s+/g, ' ').trim();
    return s || t;
  }
  function img(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 240); }

  function box() { return document.querySelector('[data-dl-bundle]'); }
  function idInput(b) {
    var sec = b.closest('.shopify-section') || document;
    return sec.querySelector('form.product-form [name="id"]') || document.querySelector('form.product-form [name="id"]');
  }
  function currentVariant(b) { var i = idInput(b); return String(i ? i.value : b.getAttribute('data-variant')); }

  var lastCart = null, justAdded = false;

  // Keep the bundle preview in step with the selected colour / size.
  var vmap = null;
  function syncVariant(b) {
    if (vmap === null) { var s = b.querySelector('[data-dl-bx-variants]'); try { vmap = s ? JSON.parse(s.textContent) : {}; } catch (e) { vmap = {}; } }
    var vid = currentVariant(b), v = vmap[vid];
    if (!v) return;
    b.setAttribute('data-variant', vid);
    if (v.img) b.setAttribute('data-image', v.img);
    if (v.price) b.setAttribute('data-price', v.price);
    var cta = b.querySelector('[data-dl-bx-cta]'); if (cta) cta.disabled = !v.available;
  }

  function draw(cart) {
    lastCart = cart;
    var b = box(); if (!b) return;
    syncVariant(b);
    var u = units(cart), n = u.length, max = n >= 3 ? 5 : 3;
    nudge(cart, n);
    var vid = currentVariant(b);
    var inCart = cart.items.some(function (i) { return String(i.variant_id) === vid; });
    var html = '';
    for (var k = 1; k <= max; k++) {
      var it = u[k - 1], gift = k === 3 || k === 5, next = k === n + 1;
      if (it) {
        html += '<div class="dl-bx__slot is-filled">' +
          '<span class="dl-bx__frame">' + (it.image ? '<img src="' + esc(img(it.image)) + '" alt="' + esc(it.product_title) + '" loading="lazy">' : '') +
          '<i class="dl-bx__tick" aria-hidden="true">&#10003;</i>' +
          '<button type="button" class="dl-bx__x" data-dl-swap="' + esc(it.key) + '" data-qty="' + it.quantity + '" aria-label="Swap out ' + esc(it.product_title) + '">&times;</button></span>' +
          '<span class="dl-bx__lbl">' + esc(shortName(it.product_title)) + '</span>' +
          '<button type="button" class="dl-bx__swap" data-dl-swap="' + esc(it.key) + '" data-qty="' + it.quantity + '">Swap</button></div>';
      } else if (!inCart && next) {
        html += '<div class="dl-bx__slot is-preview' + (gift ? ' is-gift' : '') + '"><span class="dl-bx__frame"><img src="' + esc(b.getAttribute('data-image')) + '" alt="" loading="lazy">' +
          (gift ? '<b class="dl-bx__free">FREE</b>' : '') + '</span><span class="dl-bx__lbl">This one</span></div>';
      } else {
        var lbl = gift ? (k === 3 ? '3rd is FREE' : '5th is FREE') : 'Your ' + ORD[k] + ' pick';
        var hot = inCart && next;
        if (hot) lbl = gift ? 'Pick your FREE one &darr;' : 'Pick your ' + ORD[k] + ' &darr;';
        html += '<div class="dl-bx__slot' + (gift ? ' is-gift' : '') + (hot ? ' is-next' : '') + '"><span class="dl-bx__frame"><i class="dl-bx__plus">+</i>' +
          (gift ? '<b class="dl-bx__free">FREE</b>' : '') + '</span><span class="dl-bx__lbl">' + lbl + '</span></div>';
      }
    }
    b.querySelector('[data-dl-bx-slots]').innerHTML = html;
    b.querySelector('[data-dl-bx-count]').textContent = Math.min(n, max) + ' of ' + max;
    b.classList.toggle('is-active', inCart);
    b.classList.toggle('is-bonus', n >= 3);
    b.classList.toggle('is-wide', max === 5);

    var top = b.querySelector('[data-dl-bx-top]'), label = b.querySelector('[data-dl-bx-label]'), help = b.querySelector('[data-dl-bx-help]');
    var cta = b.querySelector('[data-dl-bx-cta]');
    if (!inCart) {
      top.hidden = true;
      var dlFree = isFree(b, n, u);
      label.innerHTML = '+ Add to bundle · ' + priceHtml(b.getAttribute('data-price'), dlFree) + (!dlFree && (n === 2 || n === 4) ? ' · unlocks 1 FREE' : '');
      basketLabel(b, dlFree);
      help.textContent = n === 0 ? 'Adds it to your basket and keeps you here to pick 2 more. Cheapest is FREE.'
        : n === 1 ? 'Adds it to your basket and unlocks a FREE item.'
        : n === 2 ? 'Add it now and the cheapest of your 3 is FREE.'
        : n === 3 ? 'Bonus offer: add 1 more and get another item FREE.'
        : n === 4 ? 'Add it now for your 2nd FREE item.'
        : 'You have 2 FREE items. Max 2 free per order.';
      cta.setAttribute('data-mode', 'add');
    } else {
      top.hidden = false;
      var L = ['', 'Pick your 2nd piece ↓', 'Pick your FREE 3rd piece ↓', 'Bonus: pick your 4th piece ↓', 'Pick your 2nd FREE piece ↓', 'View basket'];
      basketLabel(b, false);
      label.textContent = L[Math.min(n, 5)] || 'View basket';
      help.textContent = n <= 1 ? 'Tap any item below to see it and then add from its page'
        : n === 2 ? 'FREE item unlocked. The cheapest of your 3 comes off at checkout.'
        : n === 3 ? 'Bonus offer unlocked: add 2 more and your 2 cheapest are FREE.'
        : n === 4 ? 'Add 1 more and it’s FREE.'
        : 'Congrats, your 2 cheapest items are FREE!';
      cta.setAttribute('data-mode', n >= 5 ? 'basket' : 'scroll');
    }
    // 5+ items: both FREE items unlocked, so the main button becomes a green "Go to checkout".
    var go = n >= 5;
    cta.classList.toggle('is-checkout', go);
    if (go) {
      top.hidden = false; top.textContent = '✓ 2 FREE items unlocked';
      label.textContent = 'Go to checkout →';
      cta.setAttribute('data-mode', 'checkout');
      cta.disabled = false;
    } else top.textContent = '✓ Item added';
    var ag = b.querySelector('[data-dl-bx-again]');
    if (ag) {
      var mine = 0;
      cart.items.forEach(function (i) { if (String(i.variant_id) === vid) mine += i.quantity; });
      ag.hidden = !inCart;
      if (ag.__oos && (ag.__oos.vid !== vid || mine < ag.__oos.qty)) ag.__oos = null;
      ag.disabled = !!ag.__oos;
      ag.textContent = ag.__oos ? 'That’s all we have of this one, it’s all in your bundle' : 'Add this item again';
    }
    var co = b.querySelector('[data-dl-bx-checkout]');
    if (co) co.hidden = n < 3;
    ship(b, cart);
    if (justAdded) { b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump'); justAdded = false; }

    // Carousel: mark pieces already in the bundle.
    var handles = {};
    cart.items.forEach(function (i) { handles[i.handle] = true; });
    document.querySelectorAll('.dl-car__card').forEach(function (c) {
      var on = !!handles[c.getAttribute('data-handle')];
      c.classList.toggle('is-in', on);
      var t = c.querySelector('[data-dl-tag]');
      if (t) t.textContent = on ? '✓ In your bundle' : t.getAttribute('data-dl-tag');
    });
  }

  // Kids pages: once 3+ pieces are in and they're all kids pieces, suggest something for the grown-up.
  // "Grown-ups" moves next to "All", with a pointing arrow and a shimmer.
  var kidsSet = null;
  function nudge(cart, n) {
    var car = document.querySelector('[data-dl-carousel]'); if (!car) return;
    var src = car.querySelector('[data-dl-kids-handles]'), msg = car.querySelector('[data-dl-nudge]');
    if (!src || !msg) return;
    if (!kidsSet) { try { kidsSet = JSON.parse(src.textContent) || []; } catch (e) { kidsSet = []; } }
    var picks = cart.items.filter(function (i) { return SPARE.indexOf(i.handle) === -1 && !i.gift_card && (i.product_type || '').toLowerCase() !== 'add-on'; });
    var on = n >= 3 && kidsSet.length > 0 && picks.length > 0 && picks.every(function (i) { return kidsSet.indexOf(i.handle) > -1; });
    var was = car.classList.contains('is-nudge');
    var chips = car.querySelector('.dl-car__chips'); if (!chips) return;
    var x = chips.querySelector('[data-dl-chip="x"]'), all = chips.querySelector('[data-dl-chip="all"]'), pt = chips.querySelector('.dl-car__point');
    if (!x || !all) return;
    car.classList.toggle('is-nudge', on);
    if (on && !was) { if (pt) all.insertAdjacentElement('afterend', pt); (pt || all).insertAdjacentElement('afterend', x); x.textContent = 'Grown-ups'; }
    else if (!on && was) { chips.appendChild(x); x.textContent = 'For grown-ups'; }
  }

  var FREE_SHIP = 5000;
  function money(p) { var v = p / 100; return '£' + (v % 1 ? v.toFixed(2) : String(v)); }
  function ship(b, cart) {
    var s = b.querySelector('[data-dl-bx-ship]'); if (!s) return;
    var t = cart.total_price || 0, left = FREE_SHIP - t, on = left <= 0;
    s.classList.toggle('is-on', on);
    var bar = s.querySelector('[data-dl-bx-ship-bar]'); if (bar) bar.style.width = (on ? 100 : Math.round(t / FREE_SHIP * 100)) + '%';
    var tx = s.querySelector('[data-dl-bx-ship-txt]');
    if (tx) tx.innerHTML = on ? '<b>Free delivery activated</b> &#10003;' : (cart.item_count ? '<b>' + money(left) + ' to go</b> for free UK delivery' : '<b>Free UK delivery</b> on orders over £50');
  }

  function refresh() { if (window.DelilahCart) DelilahCart.get().then(draw).catch(function () {}); }

  document.addEventListener('click', function (e) {
    var cta = e.target.closest && e.target.closest('[data-dl-bx-cta]');
    if (cta) {
      e.preventDefault();
      var b = box(), mode = cta.getAttribute('data-mode') || 'add';
      if (mode === 'scroll') {
        var car = document.querySelector('[data-dl-carousel]');
        if (car) { car.scrollIntoView({ behavior: 'smooth', block: 'center' }); car.classList.remove('is-glow'); void car.offsetWidth; car.classList.add('is-glow'); }
        return;
      }
      if (mode === 'basket') { document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } })); return; }
      if (mode === 'checkout') { window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'checkout'; return; }
      if (cta.getAttribute('aria-busy') === 'true') return;
      cta.setAttribute('aria-busy', 'true');
      DelilahCart.add(currentVariant(b), 1, false)
        .then(function (cart) { justAdded = true; draw(cart); })
        .catch(function (err) { var h = b.querySelector('[data-dl-bx-help]'); if (h) h.textContent = (err && (err.description || err.message)) || 'Sorry, that could not be added.'; })
        .then(function () { cta.removeAttribute('aria-busy'); });
      return;
    }
    // "View basket" opens the side cart (falls back to the basket page).
    var vb = e.target.closest && e.target.closest('[data-dl-bx-checkout]');
    if (vb) {
      var dbtn = document.querySelector('a.cart-drawer-button[aria-controls="CartDrawer"]') || document.querySelector('.cart-drawer-button');
      if (dbtn) { e.preventDefault(); dbtn.click(); }
      return;
    }
    var again = e.target.closest && e.target.closest('[data-dl-bx-again]');
    if (again) {
      e.preventDefault();
      if (again.getAttribute('aria-busy') === 'true') return;
      again.setAttribute('aria-busy', 'true');
      var bb = box();
      DelilahCart.add(currentVariant(bb), 1, false)
        .then(function (cart) { justAdded = true; draw(cart); })
        .catch(function (err) {
          var msg = (err && (err.description || err.message)) || '';
          if (/maximum quantity|stock|available/i.test(msg) && lastCart) {
            var q = 0, v = currentVariant(bb);
            lastCart.items.forEach(function (i) { if (String(i.variant_id) === v) q += i.quantity; });
            again.__oos = { vid: v, qty: q };
            draw(lastCart);
          } else { var h = bb.querySelector('[data-dl-bx-help]'); if (h) h.textContent = msg || 'Sorry, that could not be added.'; }
        })
        .then(function () { again.removeAttribute('aria-busy'); });
      return;
    }
    var sw = e.target.closest && e.target.closest('[data-dl-swap]');
    if (sw) {
      e.preventDefault();
      var q = Math.max(0, Number(sw.getAttribute('data-qty') || 1) - 1);
      sw.disabled = true;
      DelilahCart.change(sw.getAttribute('data-dl-swap'), q).then(draw).catch(refresh);
      return;
    }
    var arr = e.target.closest && e.target.closest('[data-dl-car-arrow]');
    if (arr) {
      var trk = document.querySelector('.dl-car__track');
      if (trk) { var dir = arr.getAttribute('data-dl-car-arrow') === 'next' ? 1 : -1; trk.scrollBy({ left: dir * Math.max(160, trk.clientWidth * 0.8), behavior: 'smooth' }); }
      return;
    }
    var chip = e.target.closest && e.target.closest('[data-dl-chip]');
    if (chip) {
      var f = chip.getAttribute('data-dl-chip');
      chip.parentNode.querySelectorAll('[data-dl-chip]').forEach(function (c) { c.classList.toggle('is-on', c === chip); });
      document.querySelectorAll('.dl-car__card').forEach(function (c) {
        var more = c.getAttribute('data-more');
        if (more !== null) { c.hidden = more !== f; return; }
        var cats = (c.getAttribute('data-cat') || '').split(' ');
        c.hidden = f === 'all' ? cats.indexOf('x') > -1 : cats.indexOf(f) === -1;
      });
      var tr = document.querySelector('.dl-car__track'); if (tr) { tr.scrollLeft = 0; arrows(); }
    }
  });

  // Carousel arrows (desktop): grey out at either end.
  function arrows() {
    var trk = document.querySelector('.dl-car__track'); if (!trk) return;
    var max = trk.scrollWidth - trk.clientWidth - 2;
    document.querySelectorAll('[data-dl-car-arrow]').forEach(function (a) {
      a.disabled = a.getAttribute('data-dl-car-arrow') === 'next' ? trk.scrollLeft >= max : trk.scrollLeft <= 2;
    });
  }
  function bindArrows() {
    var trk = document.querySelector('.dl-car__track'); if (!trk || trk.__dlA) return; trk.__dlA = true;
    trk.addEventListener('scroll', function () { clearTimeout(trk.__dlT); trk.__dlT = setTimeout(arrows, 60); }, { passive: true });
    window.addEventListener('resize', arrows);
    arrows();
  }

  // Turn the theme's Add to cart into "Just add to basket" (it keeps its normal behaviour: adds and opens the basket).
  function relabel() {
    var b = box(); if (!b) return;
    var sec = b.closest('.shopify-section') || document;
    sec.classList.add('dl-has-bundle');
    var btn = sec.querySelector('.product-form__submit');
    if (!btn || btn.hasAttribute('data-dl-relabelled')) return;
    btn.setAttribute('data-dl-relabelled', '');
    btn.classList.add('dl-basket-btn');
    var span = btn.querySelector('.btn-text > span');
    if (span && !span.hasAttribute('data-sold-out-shown')) span.textContent = 'Just add to basket · ' + b.getAttribute('data-price');
    var wrap = btn.closest('.buy-buttons');
    if (wrap && !wrap.parentNode.querySelector('.dl-basket-note')) {
      var p = document.createElement('p'); p.className = 'dl-basket-note'; p.textContent = 'Skips the bundle and opens your basket';
      wrap.insertAdjacentElement('afterend', p);
    }
  }

  document.addEventListener('dl:cart', function (e) { if (e.detail && e.detail.cart) draw(e.detail.cart); });
  if (window.theme && theme.pubsub) {
    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refresh, 80); });
    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, function (ev) {
      var b = box(), v = ev && (ev.data && ev.data.variant || ev.variant);
      if (b && v) { b.setAttribute('data-variant', v.id); if (v.price != null && window.theme && theme.Currency && theme.Currency.formatMoney) b.setAttribute('data-price', theme.Currency.formatMoney(v.price, theme.settings.moneyFormat)); }
      if (lastCart) draw(lastCart);
    });
  }
  // Variant picker changes (colour swatches, sizes): redraw once the theme has updated the selected variant.
  document.addEventListener('change', function (e) {
    var b = box(); if (!b || !lastCart) return;
    var sec = b.closest('.shopify-section');
    if (sec && sec.contains(e.target) && !e.target.closest('[data-dl-bundle]')) {
      [80, 300, 800].forEach(function (t) { setTimeout(function () { draw(lastCart); }, t); });
    }
  });
  function start() { relabel(); bindArrows(); refresh(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
